<template>
  <b-modal id="add_job_rate_modal" ref="add_job_rate_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1>
          <i class="fas fa-comment-dots"></i>
          <span>Add Rate(s) to Job Order</span>
        </h1>
      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>
    <div>
      <div class="row">
        <div class="col-12">
          <h5 class="bp_color"><u>Job Order Info</u></h5>
          <p class="font-weight-bold mb-0">{{ $store.state.right_info.data.company_name }}</p>
          <p class="mb-0">{{ $store.state.right_info.data.order_ref }}</p>
          <p class="font-italic" style="font-size: 0.7rem;">{{ $store.state.right_info.data.job_address_full }}</p>
          <hr>
        </div>

        <div class="col-12 mb-3" v-if="crmType === 'recruitment' && (order_type !== 'Temporary (PAYE)' || order_type !== 'Contract' || order_type !== 'Permanent') &&
        recruitment_margin_perc !== null">
          <span class="font-weight-bold">Recruitment Margin:</span> &nbsp; <span>{{ recruitment_margin_perc | percentage }}</span>
        </div>
        <div class="col-12">
          <h5 class="bp_color"><u>Current Rates</u></h5>
        </div>
        <div class="col-12" v-for="c_rate in current_rates">
          <div class="row">
            <div class="col-4">
              <span class="font-weight-bold">{{ c_rate.rate_type }} Rate:</span> &nbsp; <span>{{ c_rate.pay_amount | currency }}</span>
            </div>
            <div class="col-3">
              ({{ c_rate.pay_type }})
            </div>
            <div class="col-5">
              <span class="font-weight-bold">Admin Fee:</span> &nbsp;
              <span v-if="c_rate.admin_fee_type === '£ (Pound)'">{{ c_rate.admin_fee_amount | currency }}</span>
              <span v-if="c_rate.admin_fee_type === '% (Percentage)'">{{ c_rate.admin_fee_amount | percentage }}</span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <hr>
        </div>
        <div class="col-12">
          <ValidationObserver ref="addJobRatesForm" slim>
            <form role="form" @submit.prevent="add_job_rates()">
              <div class="row mb-3" v-for="num in num_rates">
                <div class="col-8">
                  <h5 class="font-weight-bold" style="line-height: 30px;">New Rate {{ num }}</h5>
                </div>
                <div class="col-4 text-right">
                  <button v-if="num_rates > 1" @click.prevent="remove_job_rate(num - 1)" class="btn orcaBtn danger sm_btn">
                    Remove Rate
                  </button>
                </div>
                <!-- Rate Type -->
                <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Rate Type ' + (num)" tag="div" class="col-4 form-group">
                  <label class="form-label" :for="'rate_type_' + (num - 1)">Rate Type</label>
                  <multiselect v-model="rates[num - 1].type" :id="'rate_type_' + (num - 1)" class="requiredField" :class="classes"
                               :name="'rate_type_' + (num - 1)" placeholder="" :options="ms_opts.rate_type" label="value" track-by="id"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- Pay Type -->
                <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Pay Type ' + (num)" tag="div" class="col-4 form-group">
                  <label class="form-label" :for="'pay_type_' + (num - 1)">Pay Type</label>
                  <multiselect v-model="rates[num - 1].pay_type" :id="'pay_type_' + (num - 1)" class="requiredField" :class="classes"
                               :name="'pay_type_' + (num - 1)" placeholder="" :options="ms_opts.rate_pay_types" label="value"
                               @input="multiselect_check_rate_exists($event, num)"
                               track-by="id"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- Pay Amount -->
                <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" :name="'Pay Amount ' + (num)" tag="div" class="col-4 form-group">
                  <label class="form-label" :for="'pay_amount_' + (num - 1)">Pay Amount</label>
                  <div class="input-group">
                    <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                    <input type="text" v-model="rates[num - 1].pay_amount" :id="'pay_amount_' + (num - 1)" :name="'pay_amount_' + (num - 1)"
                           class="form-input requiredField" :class="classes" @blur="check_rate_exists(num)" @input="rate_calc_recruitment_margin(rates[num - 1])">
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- Admin Fee Type -->
                <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Admin Fee Type ' + (num)" tag="div" class="col-4 form-group"
                                    v-if="order_type === 'Payroll - Contract'">
                  <label class="form-label" :for="'admin_fee_type_' + (num - 1)">Admin Fee Type</label>
                  <multiselect v-model="rates[num - 1].admin_fee_type" :id="'admin_fee_type_' + (num - 1)" class="requiredField" :class="classes"
                               :name="'admin_fee_type_' + (num - 1)" placeholder="" :options="ms_opts.fee_type" label="value" track-by="id" :disabled="true"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- Admin Fee -->
                <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" :name="'Admin Fee Amount ' + (num)" tag="div" class="col-4 form-group"
                                    v-if="order_type === 'Payroll - Contract'">
                  <label class="form-label" :for="'admin_fee_amount_' + (num - 1)">Admin Fee Amount</label>
                  <div class="input-group">
                    <div v-if="rates[num - 1].admin_fee_type !== null && rates[num - 1].admin_fee_type.value === '£ (Pound)'" class="input-group-prepend">
                      <span class="input-group-text">&pound;</span>
                    </div>
                    <div v-else-if="rates[num - 1].admin_fee_type !== null && rates[num - 1].admin_fee_type.value === '% (Percentage)'" class="input-group-prepend">
                      <span class="input-group-text">&percnt;</span>
                    </div>
                    <input type="text" v-model="rates[num - 1].admin_fee" :id="'admin_fee_amount_' + (num - 1)" :name="'admin_fee_amount_' + (num - 1)"
                           class="form-input requiredField" :class="[classes, rates[num - 1].admin_fee_type !== null ? 'requiredField' : 'disabled']"
                           :disabled="rates[num - 1].admin_fee_type === null">
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" :name="'Charge Rate ' + (num)" tag="div" class="col-4 form-group"
                                    v-else>
                  <label class="form-label" :for="'admin_fee_amount_' + (num - 1)">Charge Rate</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">&pound;</span>
                    </div>
                    <input type="text" v-model="rates[num - 1].admin_fee" :id="'admin_fee_amount_' + (num - 1)" :name="'admin_fee_amount_' + (num - 1)"
                           class="form-input">
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- Retention Percentage -->
                <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" :name="'Retention Percentage ' + (num)" tag="div" class="col-4 form-group"
                                    v-if="order_type === 'Contract' || order_type === 'Payroll - Contract'">
                  <label class="form-label" :for="'retention_percentage_' + (num - 1)">Retention Percentage</label>
                  <div class="input-group">
                    <div class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                    <input type="text" v-model="rates[num - 1].retention_percentage" :id="'retention_percentage_' + (num - 1)" :name="'retention_percentage_' + (num - 1)"
                           class="form-input requiredField" :class="classes">
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <div class="col-12">
                  <hr class="mt-1 mb-1">
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <button @click.prevent="add_another_rate" class="btn orcaBtn greenBtn" :disabled="saving">Add Another Rate</button>
                </div>
                <div class="col-6">
                  <button type="submit" class="btn orcaBtn" :disabled="saving">
                    <span v-if="!saving">Save New Rate(s)</span>
                    <span v-else-if="saving"><i class="fas fa-spinner fa-spin"></i> Saving New Rate(s) ...</span>
                  </button>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import { calculateRate } from 'utils/utils';

export default {
  name: "add_rate",
  components: {
    Multiselect
  },
  data() {
    return {
      num_rates: 1,
      fixed_amount: this.$store.state.right_info.data.fee_margin_amount,
      rates: [
        {
          type: {value: 'Basic', id: 15},
          pay_type: null,
          pay_amount: '',
          admin_fee_type: null,
          admin_fee: this.$store.state.right_info.data.fee_margin_amount,
          retention_percentage: '5',
        }
      ],
      current_rates: this.$store.state.order_rates.current_rates,
      order_type: this.$store.state.order_rates.order_type,
      recruitment_margin_perc: this.$store.state.order_rates.recruitment_margin_perc,
      ms_opts: {
        rate_type: this.$store.state.crm_options.rate_type,
        rate_pay_types: this.$store.state.crm_options.pay_type,
        fee_type: this.$store.state.crm_options.fee_type,
      },

      saving: false
    }
  },
  beforeMount() {
    if (this.crmType === 'recruitment' &&
        (this.$store.state.right_info.data.order_type !== 'Payroll - Contract' && this.$store.state.right_info.data.order_type !== 'Payroll - PAYE')) {
      this.rates[0].admin_fee_type = {value: '£ (Pound)', id: 37}
    }
    else {
      if (this.$store.state.right_info.data.fee_margin_type === '£ (Pound)') {
        this.rates[0].admin_fee_type = {value: '£ (Pound)', id: 37}
      }
      else if (this.$store.state.right_info.data.fee_margin_type === '% (Percentage)') {
        this.rates[0].admin_fee_type = {value: '% (Percentage)', id: 38}
      }
      else {
        this.rates[0].admin_fee_type = null;
      }
    }
  },
  methods: {
    hideModal() {
      this.$refs.add_job_rate_modal.hide();
      this.$store.commit('HIDE_JOB_RATE_MODAL');
    },
    add_job_rates() {
      this.$refs.addJobRatesForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.addJobRatesForm);
        }
        else {
          this.saving = true;
          let rate_promises = [];

          for (let r = 0; r < this.num_rates; r++) {
            rate_promises.push(new Promise(resolve => {
              let position_rate = {
                order_job_id: this.$store.state.order_rates.current_order_job_id,
                rate_type: this.rates[r].type.value,
                pay_type: this.rates[r].pay_type.value,
                pay_amount: this.rates[r].pay_amount,
                admin_fee_type: this.rates[r].admin_fee_type.value,
                admin_fee_amount: this.rates[r].admin_fee,
                retention_percentage: this.rates[r].retention_percentage,
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id
              };
              axios.post(this.crmApiPath + 'order/position_rate', position_rate).then(() => resolve());
            }));
          }
          Promise.all(rate_promises).then(() => {
            this.$bus.$emit('order_rates::reload', {action: true});
            this.hideModal()
          });
        }
      });
    },
    multiselect_check_rate_exists(value, index) {
      if (value !== null) {
        let check = this.current_rates.filter(rate => rate.pay_amount === parseFloat(this.rates[index - 1].pay_amount) && rate.pay_type === value.value);
        if (check.length > 0) {
          this.popup_rate_exists(value.value, this.rates[index - 1].pay_amount, index - 1)
        }
      }
    },
    check_rate_exists(index) {
      if (this.rates[index - 1].pay_type !== null) {
        let check = this.current_rates.filter(rate => rate.pay_amount === parseFloat(this.rates[index - 1].pay_amount) && rate.pay_type === this.rates[index - 1].pay_type.value);
        if (check.length > 0) {
          this.popup_rate_exists(this.rates[index - 1].pay_type.value, this.rates[index - 1].pay_amount, index - 1)
        }
      }
    },
    popup_rate_exists(pay_type, pay_amount, index) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Rate Already Exists</div>' +
            '<div class="snotifyToast__body">' +
            this.$store.state.right_info.data.order_ref + ' already has a ' + pay_type + ' £' + pay_amount + ' rate' + '<br><br>' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Clear Rate', action: (toast) => {
              this.rates[index].pay_amount = '';
              this.$snotify.remove(toast.id);
            }
          },
        ]
      });
    },

    add_another_rate() {
      let admin_fee_type = null;
      if (this.$store.state.right_info.data.fee_margin_type === '£ (Pound)') {
        admin_fee_type = {value: '£ (Pound)', id: 37}
      }
      else if (this.$store.state.right_info.data.fee_margin_type === '% (Percentage)') {
        admin_fee_type = {value: '% (Percentage)', id: 38}
      }

      this.rates.push({
        type: {value: 'Basic', id: 15},
        pay_type: null,
        pay_amount: '',
        admin_fee_type: admin_fee_type,
        admin_fee: this.$store.state.right_info.data.fee_margin_amount,
        retention_percentage: '5',
      })
      this.$nextTick(() => this.num_rates++)
    },
    remove_job_rate(index) {
      this.num_rates = this.num_rates - 1;
      this.$nextTick(() => this.rates.splice(index, 1))
    },

    rate_calc_recruitment_margin(rate) {

      if(this.$store.state.right_info.data.fee_margin_type === '% (Percentage)') {
          rate.admin_fee = this.fixed_amount;   
      } else {
          rate.admin_fee = calculateRate(rate.pay_amount, this.crmType, this.order_type, this.recruitment_margin_perc, rate.admin_fee);
      }

    },
  }
}
</script>

<style scoped>

</style>
